<div class="assigned-zone-form">
    @if (isLoadingZones()) {
    <div class="flex items-center justify-center py-8">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    } @else {
    <form [formGroup]="form" class="space-y-4">
        <!-- Parking Zones Multi-Select -->
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Parking Zones</mat-label>
            <mat-select formControlName="availableForParkingZones" multiple>
                @for (zone of availableZones(); track zone.id) {
                <mat-option [value]="zone.id">
                    <div class="flex items-center gap-2">
                        <mat-icon class="text-base text-purple-600">location_on</mat-icon>
                        <span>{{ zone.name }}</span>
                    </div>
                </mat-option>
                }
            </mat-select>
            <mat-hint>Optional: Select zones this type applies to</mat-hint>
        </mat-form-field>

        <!-- Availability Period -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available From</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="availableFrom">
                <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for immediate availability</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available To</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="availableTo">
                <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for no end date</mat-hint>
            </mat-form-field>
        </div>

        <!-- Info Box -->
        <div class="bg-purple-50 border border-purple-200 rounded-lg p-3">
            <div class="flex items-start gap-2">
                <mat-icon class="text-purple-600 text-sm">info</mat-icon>
                <div class="text-sm text-purple-800">
                    <p><strong>Assigned Zone Parkers:</strong> This type allows specific parkers to be assigned to
                        designated parking zones with exclusive access during the specified period.</p>
                </div>
            </div>
        </div>
    </form>
    }
</div>